// Configuración del cliente Sedapar (Arequipa)
export default {
  cliente: "sedapar",
  titulo: "Geodir Maps | Sedapar",
  centro: { lat: -16.3989, lng: -71.5369 }, // Arequipa
  zoom: 13,
  logo: require("../../../assets/images/sedapar-logo.png"),
};